import { campaignFunnelRows } from '../../../mocks/funnel';

export default function FunnelTable() {
  return (
    <div className="bg-white rounded-2xl shadow-card overflow-hidden">
      <div className="px-6 py-4 border-b border-border flex items-center justify-between">
        <div>
          <h3 className="text-[15px] font-semibold text-charcoal-600">Kampanya Bazlı Funnel Performansı</h3>
          <p className="text-[12px] text-charcoal-300 mt-0.5">Her kampanya için adım adım dönüşüm analizi</p>
        </div>
        <button className="flex items-center gap-2 h-[32px] px-3.5 bg-[#FAF8F4] border border-border rounded-xl text-[12px] text-charcoal-400 hover:border-champagne-400 transition-colors cursor-pointer whitespace-nowrap">
          <div className="w-4 h-4 flex items-center justify-center"><i className="ri-download-line text-[13px]" /></div>
          CSV
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-[#FAF8F4] border-b border-border">
              {['Kampanya', 'Gösterim', 'Görüntüleme', 'Tıklama', 'WhatsApp', 'Form Gönderimi', 'Dönüşüm Oranı', 'Kayıp Oranı'].map(h => (
                <th key={h} className="px-4 py-3 text-left text-[11px] font-semibold text-charcoal-300 uppercase tracking-wide whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {campaignFunnelRows.map((row, idx) => (
              <tr key={row.id} className={`border-b border-border hover:bg-[#FAF8F4] transition-colors ${idx % 2 === 0 ? '' : 'bg-[#FDFCFA]'}`}>
                <td className="px-4 py-3">
                  <span className="text-[13px] font-medium text-charcoal-600">{row.campaign}</span>
                </td>
                <td className="px-4 py-3 text-[13px] text-charcoal-500">{row.impressions.toLocaleString()}</td>
                <td className="px-4 py-3 text-[13px] text-charcoal-500">{row.views.toLocaleString()}</td>
                <td className="px-4 py-3 text-[13px] text-charcoal-500">{row.clicks.toLocaleString()}</td>
                <td className="px-4 py-3 text-[13px] text-charcoal-500">{row.whatsappClicks.toLocaleString()}</td>
                <td className="px-4 py-3 text-[13px] text-charcoal-500">{row.formSubmits.toLocaleString()}</td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    <div className="flex-1 bg-charcoal-100 rounded-full h-1.5 max-w-[60px]">
                      <div className="h-1.5 rounded-full bg-champagne-500" style={{ width: `${(row.conversionRate / 12) * 100}%` }} />
                    </div>
                    <span className="text-[13px] font-semibold text-champagne-600">{row.conversionRate}%</span>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    <div className="flex-1 bg-charcoal-100 rounded-full h-1.5 max-w-[60px]">
                      <div className="h-1.5 rounded-full bg-red-300" style={{ width: `${(row.dropOffRate / 45) * 100}%` }} />
                    </div>
                    <span className="text-[13px] font-semibold text-red-400">{row.dropOffRate}%</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
